import React from "react";

/**
 * Export dropdown menu component
 * Provides options to export price changes or all prices
 */
const ExportMenu = ({
  anchorEl,
  onClose,
  onExportChanges,
  onExportAll,
  hasChanges,
}) => {
  if (!anchorEl) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 z-40" onClick={onClose} />

      {/* Dropdown Menu */}
      <div className="absolute right-0 mt-2 w-64 rounded-xl shadow-2xl bg-white border border-gray-200 z-50 overflow-hidden">
        <div className="py-2">
          <button
            onClick={() => {
              onExportChanges();
              onClose();
            }}
            disabled={!hasChanges}
            className="flex items-center w-full text-left px-4 py-3 text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-150 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-gray-700"
          >
            <svg
              className="w-5 h-5 mr-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
              />
            </svg>
            <div>
              <div>Export Changes</div>
              <div className="text-xs text-gray-500 mt-0.5">
                Export modified prices only
              </div>
            </div>
          </button>

          <div className="border-t border-gray-100 my-1"></div>

          <button
            onClick={() => {
              onExportAll();
              onClose();
            }}
            className="flex items-center w-full text-left px-4 py-3 text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-150"
          >
            <svg
              className="w-5 h-5 mr-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <div>
              <div>Export All Prices</div>
              <div className="text-xs text-gray-500 mt-0.5">
                Export complete price list
              </div>
            </div>
          </button>
        </div>
      </div>
    </>
  );
};

export default ExportMenu;
